import { PLAN_KINDS } from './constants'
import type { Account, PlanKind } from './types'

export const isSingleProjectPlan = (planKind?: PlanKind) =>
  planKind === PLAN_KINDS.single_project

export const isTrialPlan = (planKind?: PlanKind) =>
  planKind === PLAN_KINDS.trial

export const allowsManyProjects = (planKind?: PlanKind) =>
  !isSingleProjectPlan(planKind) && !isTrialPlan(planKind)

export const isCreditsPlan = (planKind?: PlanKind) =>
  planKind === PLAN_KINDS.subscription ||
  isSingleProjectPlan(planKind) ||
  isTrialPlan(planKind)

export const hasTrialEnded = (account?: Account | null) => {
  if (!account?.trialEndsAt) return false
  return new Date(account.trialEndsAt) <= new Date()
}
